/** @format */

import ResourceIndex from "./ResourceIndex";
import ResourcePage from "./resourcePage/ResourcePage";

import SubjectPage from "../subject/SubjectPage";
import SubjectsIndex from "../subject/SubjectsIndex";
import UploadBL from "./upload/UploadBL";
import UploadOther from "./upload/UploadOther";
import SelectResource from "./selectResource/SelectResource";
import AuthFlag from "../auth/AuthFlag";
import PageNotFound from "../pageNotFound/PageNotFound";

const resourcesRoutes = [
  {
    index: true,
    element: <SubjectsIndex />,
  },
  {
    path: ":subject",
    element: <SubjectPage />,
    children: [
      {
        index: true,
        element: <ResourceIndex />,
      },
      {
        path: "r/:resourceId/:type/:qualification",
        element: <ResourcePage />,
      },
    ],
  },
  {
    path: "upload-bl",
    element: (
      <AuthFlag authGroup={["wjec", "admin"]} fallback={<PageNotFound itemName="Page" />}>
        <UploadBL />
      </AuthFlag>
    ), // TODO: should user token be checked here?
  },
  {
    path: "upload",
    element: (
      <AuthFlag authGroup={["wjec", "admin"]} fallback={<PageNotFound itemName="Page" />}>
        <UploadOther />
      </AuthFlag>
    ),
  },
  {
    path: "select-resource",
    element: (
      <AuthFlag authGroup={["wjec", "admin"]} fallback={<PageNotFound itemName="Page" />}>
        <SelectResource />
      </AuthFlag>
    ),
  },
];

export default resourcesRoutes;
